/** §7.M3 Upload/Video modality — a file picker (Upload: photo from library;
 * Video: camera viewfinder via `capture`). The picked File becomes the single
 * media part via `roleForModality` (Upload→primary_photo; Video→voice_annotation,
 * whose audio is transcribed server-side, so the Summary shows no transcript
 * yet — "transcript pending"). */
export function CaptureFileEntry({
  accept,
  capture,
  title,
  testidPrefix,
  onFile,
  onCancel,
}: {
  accept: string;
  capture?: string;
  title: string;
  testidPrefix: string;
  onFile: (file: File) => void;
  onCancel: () => void;
}) {
  return (
    <section data-testid={`${testidPrefix}-entry`} style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "16px" }}>
      <h2 style={{ fontSize: "20px", fontWeight: 700, color: "var(--mark-text-primary)", margin: 0 }}>{title}</h2>
      <input
        type="file"
        accept={accept}
        capture={capture}
        data-testid={`${testidPrefix}-input`}
        onChange={(e) => {
          const file = (e.currentTarget as HTMLInputElement).files?.[0];
          if (file) onFile(file);
          (e.currentTarget as HTMLInputElement).value = "";
        }}
        style={{ color: "var(--mark-text-primary)", fontFamily: "inherit" }}
      />
      <button
        type="button"
        data-testid={`${testidPrefix}-cancel`}
        onClick={onCancel}
        style={{ minHeight: "44px", border: "none", borderRadius: "22px", padding: "0 20px", background: "none", color: "var(--mark-text-muted)", fontFamily: "inherit", cursor: "pointer", alignSelf: "flex-start" }}
      >
        Cancel
      </button>
    </section>
  );
}
